import React from 'react'

// set the defaults
const MainContext = React.createContext({
  filterNavString: '',
  setFilterNavString: () => {},
})

export default MainContext
